
















































import {
  defineComponent,
  onMounted,
  computed,
  ref,
} from "@vue/composition-api";
import useStaggeredGridReveal from "~/mixins/useStaggeredGridReveal";
import Triangles from "~/components/partials/Triangles.vue";

export default defineComponent({
  name: "TechnicalSkills",

  components: {
    Triangles,
  },

  props: {},

  setup() {
    const technicalEntries = ref([
      {
        title: "Frontend Technologies",
        bullets: [
          "HTML5",
          "CSS3",
          "Javascript",
          "VueJS",
          "VueX",
          "Sass CSS",
          "npm",
        ],
      },
      {
        title: "Backend Technologies",
        bullets: ["PHP", "C#", "Laravel", "SQL Server"],
      },
      {
        title: "Concepts and Tools",
        bullets: [
          "Agile Development",
          "MVC Patterns",
          "Object Oriented Programming",
          "Git Version Control",
          "PHP Storm",
          "Visual Studio Code",
        ],
      },
    ]);

    const visibleElementsCount = ref(0);
    const entriesCount = computed(() => technicalEntries.value.length);

    // Mixin.
    const grid = ref<HTMLElement>(null);
    const { observeGrid } = useStaggeredGridReveal();

    onMounted(() => observeGrid(grid, visibleElementsCount, entriesCount));

    return {
      grid,
      technicalEntries,
      visibleElementsCount,
    };
  },
});
